import { i18n } from '@/i18n'
import Roles from '@/config/roles'
import store from '@/store'

export default (params) => {
  const role = store.getters['auth/role']
  const sedes = {
    name: i18n.t('sedes.header'),
    path: 'masters/society/locations',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const linkedCompanies = {
    name: i18n.t('companies.companies_link'),
    path: 'masters/society/linkedcompanies',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const usersProviders = {
    name: i18n.t('users.users_link'),
    path: 'masters/society/usersproviders',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1' || !params.selfInvoice,
    invisible: !params.selfInvoice,
    sc: [] // shorcuts
  }
  const historical = {
    name: i18n.t('historical.entity_name'),
    path: 'masters/society/historical',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const menu = [
    {
      icon: 'config',
      name: i18n.t('agenda.sociedad'),
      path: 'masters/society',
      use_parent_params: true,
      params_required: ['id', 'selfInvoice'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'masters/society/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ]
    }
  ]
  if (!params.issuingCreation && role !== Roles.Proveedor) {
    menu[0].sc.push(sedes)
    menu[0].sc.push(linkedCompanies)
    menu[0].sc.push(usersProviders)
  }
  menu[0].sc.push(historical)
  return menu
}
